














































































































import { localISODate } from "@/utils/localDate";
import { Component, Vue, Prop } from "vue-property-decorator";
import KepatuhanJatuhStore from "@/store/modules/KepatuhanJatuhStore";
import { SignTier } from "@/types/KepatuhanJatuh";

@Component
export default class TandaTanganStep extends Vue {
  @Prop({ default: null }) session!: any;

  tiers: Array<{ key: SignTier; label: string; password: string }> = [
    { key: "petugas", label: "Petugas / Observer", password: "" },
    { key: "verifikator", label: "Verifikator / PIC Mutu", password: "" },
    { key: "ka_ruangan", label: "Kepala Ruangan", password: "" }
  ];

  tanggalVerifikasi = localISODate();
  msg = "";
  err = "";
  signing: SignTier | null = null;
  publishing = false;
  revoking = false;

  get store() {
    return KepatuhanJatuhStore;
  }

  isSigned(k: string) {
    return !!(
      this.session &&
      this.session.signed &&
      this.session.signed[k] &&
      this.session.signed[k].at
    );
  }

  signedName(k: string) {
    return (
      this.session &&
      this.session.signed &&
      this.session.signed[k] &&
      this.session.signed[k].nama
    );
  }

  signedAt(k: string) {
    const at =
      this.session &&
      this.session.signed &&
      this.session.signed[k] &&
      this.session.signed[k].at;
    return at ? new Date(at).toLocaleString("id-ID") : "";
  }

  canSign(k: string) {
    if (this.isSigned(k)) return false;
    if (k === "petugas") return true;
    if (k === "verifikator") {
      return !!(
        this.session &&
        this.session.signed &&
        this.session.signed.petugas &&
        this.session.signed.petugas.at
      );
    }
    if (k === "ka_ruangan") {
      return !!(
        this.session &&
        this.session.signed &&
        this.session.signed.verifikator &&
        this.session.signed.verifikator.at
      );
    }
    return false;
  }

  get canPublish() {
    return !!(
      this.session &&
      this.session.signed &&
      this.session.signed.ka_ruangan &&
      this.session.signed.ka_ruangan.at &&
      this.session.status !== "published"
    );
  }

  get isPublished() {
    return this.session && this.session.status === "published";
  }

  async doSign(tier: SignTier, password: string) {
    this.err = "";
    this.msg = "";
    if (!password) {
      this.err = "PIN / Password wajib diisi";
      return;
    }
    this.signing = tier;
    try {
      await this.store.sign({
        id: this.session.id,
        tier,
        password,
        tanggalVerifikasi:
          tier === "ka_ruangan" ? this.tanggalVerifikasi : undefined
      });
      this.msg = `${tier} berhasil ditandatangani.`;
      // Clear password
      const t = this.tiers.find(x => x.key === tier);
      if (t) t.password = "";
    } catch (e) {
      this.err =
        e.response?.data?.message || e.message || "Gagal tanda tangan";
    } finally {
      this.signing = null;
    }
  }

  async doPublish() {
    this.err = "";
    this.msg = "";
    this.publishing = true;
    try {
      await this.store.publish(this.session.id);
      this.msg = "Sesi berhasil di-publish.";
      this.$emit("published");
    } catch (e) {
      this.err = e.response?.data?.message || e.message || "Gagal publish";
    } finally {
      this.publishing = false;
    }
  }

  async doRevoke() {
    if (!confirm("Revoke sesi yang sudah di-publish?")) return;
    this.err = "";
    this.msg = "";
    this.revoking = true;
    try {
      await this.store.revoke(this.session.id);
      this.msg = "Sesi berhasil di-revoke.";
    } catch (e) {
      this.err = e.response?.data?.message || e.message || "Gagal revoke";
    } finally {
      this.revoking = false;
    }
  }
}
